<app-customer-details-banner
  [customer]="customer()"
  [nameForm]="nameForm"
  [iconForm]="iconForm"
  [isEditingName]="isEditingName"
  [nameSaving]="isCreatingCustomer()"
  [nameErrorMessage]="nameError()"
  (nameEditingChanged)="onBannerNameEditingChanged($event)"
  (imageSelected)="updateIcon()"
  (imageRemoved)="updateIcon()"
  (nameSaveRequested)="onBannerNameSaveRequested()"
  #bannerComponent
/>

<app-content-container class="w-fill-available">
  @if (!hideFilters()) {
    <div class="w-full relative">
      <app-customer-details-filters
        class="tab-group-filters"
        [dateFilterState]="dateFilterState()"
        [loading]="campaignsStore.loading$()"
        [customerDetailsFilter]="customerDetailsFilter()"
        (customerDetailsFilterChanged)="onCustomerDetailsFilterChanged($event)"
        (dateRangeChanged)="onDateRangeChanged($event)"
        (selectedRangeChanged)="onSelectedRangeChanged($event)"
      />
    </div>
  }

  <mat-tab-group class="w-full profile-tab-group">
    <mat-tab>
      <ng-template mat-tab-label>
        <span data-testid="customer-details-tab-campaigns">{{
          'pages.customerDetails.tabs.campaigns' | translate
        }}</span>
      </ng-template>

      <div class="min-h-[calc(100vh-400px)] pt-7">
        @if (loadedCampaignsData() && campaigns().length === 0 && !hasUnfilteredCampaigns()) {
          <div class="flex justify-center w-full">
            <span class="opacity-50 text-center" data-testid="customer-details-tab-panel-campaigns">
              {{ 'pages.customerDetails.customerNotParticipatingInCampaigns' | translate }}
            </span>
          </div>
        } @else {
          <app-campaigns-datatable
            data-testid="customer-details-tab-panel-campaigns"
            [campaigns]="campaigns()"
            [campaignsLoading]="campaignsStore.campaignsLoading$()"
            [showCreateButton]="false"
            [total]="campaignsStore.total$()"
            [requestFilters]="{ customer__id: customerId() }"
          />
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</app-content-container>
